import { useState } from "react";
import { ConfirmDialog } from "@/components/admin/menu/shared";

/**
 * An "are you sure?" drawn by the app itself, for screens CaptainPAD shows.
 *
 * The CaptainPAD app's WebView has no handler for the browser's own popups, so
 * window.confirm answers "no" by itself without showing anything: Clear stale
 * claim and Cancel Table on a phantom table did nothing (C04 pressed it about
 * 12 times on 23 Oct). `confirmOnScreen` resolves true or false like
 * window.confirm did; render `confirmDialog` once on the page.
 */
export function useOnScreenConfirm(testId) {
  const [asking, setAsking] = useState(null);

  // A new question while one is open answers the old one "no", so no caller
  // is left waiting forever.
  const confirmOnScreen = (title, body, confirmLabel) =>
    new Promise(resolve => setAsking(prev => {
      prev?.resolve(false);
      return { title, body, confirmLabel, resolve };
    }));

  const answer = ok => {
    asking?.resolve(ok);
    setAsking(null);
  };

  const confirmDialog = (
    <ConfirmDialog
      open={Boolean(asking)}
      title={asking?.title || ""}
      body={asking?.body || ""}
      confirmLabel={asking?.confirmLabel || "Confirm"}
      onConfirm={() => answer(true)}
      onCancel={() => answer(false)}
      testId={testId}
    />
  );

  return { confirmOnScreen, confirmDialog };
}
